import { render, staticRenderFns } from "./QuestionTable.vue?vue&type=template&id=bfbc4718&scoped=true"
import script from "./QuestionTable.vue?vue&type=script&lang=js"
export * from "./QuestionTable.vue?vue&type=script&lang=js"
import style0 from "./QuestionTable.vue?vue&type=style&index=0&id=bfbc4718&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbc4718",
  null
  
)

export default component.exports